var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 11.9725V3H21V21H10.2134M3 11.9725V15.4519H4.39675M3 11.9725H10.6573V8.39162M4.39675 18.6464H3V21H10.2134M10.6573 3V5.69581M15.3808 3V7.41484M15.3808 15.5669V11.1578M15.3808 11.1578H21M15.3808 11.1578V9.55152M10.2134 21V15.5669H11.6185M16.9215 14.7007V15.5669H13.5676",
    stroke: "#A09B97",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildArea);
export default __webpack_public_path__ + "static/media/build_area.c112b356cf70cdd8ffc19a665691cc1c.svg";
export { ForwardRef as ReactComponent };